import {NgModule} from '@angular/core';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatSelectModule} from "@angular/material/select";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatIconModule} from "@angular/material/icon";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTabsModule} from "@angular/material/tabs";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSnackBar, MatSnackBarModule} from "@angular/material/snack-bar";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { PatientChargeComponent } from './patient-charge/patient-charge.component';
import { AddChargeComponent } from './patient-charge/add-charge/add-charge.component';
// import { AmazonMedicalTranscribeComponent } from './amazon-medical-transcribe/amazon-medical-transcribe/amazon-medical-transcribe.component';
// import { SidebarVideoCallComponent } from './sidebar-videoCall/sidebar-video-call/sidebar-video-call.component';
// import { CommentsComponent } from './sidebar-addCharges/comments/comments/comments.component';

// import { AddSignatureComponent } from './e-sign/add-signature/add-signature/add-signature.component'; 

@NgModule({
    declarations:[],
    imports: [
        MatAutocompleteModule,
        MatPaginatorModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatSortModule,
        MatCardModule,
        MatButtonModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        MatTabsModule,
        MatGridListModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatDialogModule,
        MatListModule,
        MatAutocompleteModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
    MatChipsModule],
    exports: [MatPaginatorModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatSnackBarModule,
        MatInputModule,
        MatListModule,
        MatTableModule,
        MatSortModule,
        MatCardModule,
        MatTooltipModule,
        MatButtonModule,
        MatTabsModule,
        MatSelectModule,
        MatIconModule,
        MatToolbarModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatChipsModule],
    providers: [],
    entryComponents: []
})
export class MaterialModule {
}
